import axios from '@/utils/ajax/index'; // 倒入 api
import fileExport from '@/utils/fileExport/index'; // 导出文件 api

// 修改会员标签
export const updatePatientTag = (data) => {
  return axios({
    url: '/member/patient/updatePatientTag',
    method: 'PUT',
    data,
    hideLoading: true,
  });
};

// 获取诊所所有标签
export const tag = (params) => {
  return axios({
    url: '/member/tag',
    method: 'get',
    params,
  });
};

//申请标签
export const applyTag = (data) => {
  return axios({
    url: '/member/tag',
    method: 'post',
    data,
  });
};

// 查询会员统计
export const getPatientsSum = (params) => {
  return axios({
    url: '/member/patient/getPatientsSum',
    method: 'get',
    params,
  });
};

// 根据会员电话或者姓名查询下拉框
export const search = (params) => {
  return axios({
    url: '/member/patient/search',
    method: 'get',
    params,
  });
};

// 新建会员
export const insertPatient = (data) => {
  return axios({
    url: '/member/patient/insertPatient',
    method: 'POST',
    data,
  });
};

// 编辑会员
export const updatePatient = (data) => {
  return axios({
    url: '/member/patient/updatePatient',
    method: 'put',
    data,
  });
};

// 获取会员基本信息详情
export const patientDetail = (params) => {
  return axios({
    url: `/member/patient/${params.patientId}/patientDetail`,
    method: 'get',
    params,
  });
};

// 获取会员列表
export const patients = (data) => {
  return axios({
    url: '/member/patient/getPatients',
    method: 'post',
    data,
  });
};

// 查询消息发送记录
export const smsRecordList = (data) => {
  return axios({
    url: '/member/record/smsRecord',
    method: 'post',
    data,
  });
};

// 查询优惠券发送记录
export const couponRecordList = (data) => {
  return axios({
    url: '/member/record/couponRecord',
    method: 'post',
    data,
  });
};

// 查询诊所短信剩余条数
export const getSurplusSmsNum = (params) => {
  return axios({
    url: '/member/sms/smsConfig',
    method: 'get',
    params,
  });
};

// 查询诊所短信模板
export const getSmsTemplate = (data) => {
  return axios({
    url: '/member/sms/smsTemplates',
    method: 'post',
    data,
  });
};

// 删除诊所短信模板
export const delSmsTemplate = (data) => {
  return axios({
    url: `/member/sms/smsTemplate/${data}`,
    method: 'DELETE',
    data,
  });
};

// 新增诊所短信模板
export const addSmsTemplate = (data) => {
  return axios({
    url: '/member/sms/smsTemplate',
    method: 'post',
    data,
  });
};

// 修改诊所短信模板
export const updateSmsTemplate = (data) => {
  return axios({
    url: '/member/sms/smsTemplate',
    method: 'put',
    data,
  });
};

// 发送诊所短信模板
export const sendSms = (data) => {
  return axios({
    url: '/member/sms/sendMessage',
    method: 'post',
    data,
  });
};

// 发送诊所优惠券
export const sendCoupon = (data) => {
  return axios({
    url: '/member/sms/sendCoupon',
    method: 'post',
    data,
  });
};

// 查询购买的短信包信息
export const getSmsPurchaseConfig = (params) => {
  return axios({
    url: '/member/sms/smsPageInfo/getPageInfoList',
    method: 'get',
    params,
  });
};

// 购买短信包生成预订单
export const getSmsPurchaseOrdeSn = (data) => {
  return axios({
    url: `/member/smsOrder/buy/${data}`,
    method: 'post',
    data,
  });
};

// 扫码枪间接购买短信支付
export const scanPaySmsOrder = (data) => {
  return axios({
    url: '/member/smsOrder/scanPay',
    method: 'post',
    data,
  });
};

// 直接扫码购买短信包
export const directPaySmsOrder = (params) => {
  return axios({
    url: '/member/smsOrder/deskPay',
    method: 'post',
    params,
  });
};

// 查询订单状态
export const checkOrderStatus = (params) => {
  return axios({
    url: '/member/smsOrder/checkOrderStatus',
    method: 'get',
    params,
  });
};

// 查询购买成功的短信包记录
export const getAllSmsPayRecord = (params) => {
  return axios({
    url: '/member/smsOrder/',
    method: 'get',
    params,
  });
};

// 导出会员列表信息
export const exportMember = (params) => {
  const path = '/member/patient/exportPatientInfo';
  fileExport(path, params);
};

// 导入会员模板下载
export const importMemberTemplate = (params) => {
  const path = '/member/patient/downloadTemplate';
  fileExport(path, params);
};

export default {
  tag,
  updatePatientTag,
  applyTag,
  search,
  getPatientsSum,
  insertPatient,
  updatePatient,
  patientDetail,
  smsRecordList,
  couponRecordList,
  getSurplusSmsNum,
  getSmsTemplate,
  delSmsTemplate,
  addSmsTemplate,
  sendSms,
  sendCoupon,
  getSmsPurchaseConfig,
  getSmsPurchaseOrdeSn,
  scanPaySmsOrder,
  directPaySmsOrder,
  checkOrderStatus,
  getAllSmsPayRecord,
  exportMember,
  importMemberTemplate,
  updateSmsTemplate,
};
